import ajax from './ajax';
import loading from './loading';
import currencyFormat from './currencyFormat';

export default function helpers() {

    var Site = global.Site || {};

    (function(app) {
        'use strict';
    
        app.helpers = {};
    
        var _this = app.helpers;
    
        _this.init = function() {
    
          ajax();

          loading();

          currencyFormat();
    
        };
    
    })(Site);

    global.Site = $.extend(global.Site, Site);

}

